import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";

const InvoicesDetails = ({ ...props }) => {
  const [parsedTime, setParsedTime] = useState("");

  const convertData = (time) => {
    const dateObj = new Date(time);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };

    const formattedDate = dateObj.toLocaleString("en-US", options);
    setParsedTime(formattedDate);
  };

  const download = (link) => {
    const anchor = document.createElement('a');
    anchor.href = link;
    anchor.download = `Order_invoice_${parsedTime}.pdf'`;
    anchor.target = '_blank';
    
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  useEffect(() => {
    convertData(props.invoice.orderDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper elevation={3} style={{ display: 'flex', alignItems: 'center', flex: '1', flexWrap: 'wrap', justifyContent: 'space-between', padding: '25px' }}>
      <div style={{ marginBottom: "5px" }}>
        <strong>Order date: </strong>
        {parsedTime}
      </div>
      <div style={{ marginBottom: "5px" }}>
        <strong>Invoice: </strong>
          <Chip
            onClick={() => download(props.invoice.orderInvoice)}
            label="Open and Download"
            variant="outlined"
            color="success"
          />
      </div>
    </Paper>
  );
};

export default InvoicesDetails;
